// src/Routes/Tools/ToolsPage.tsx
import { useParams, Navigate } from "react-router-dom";
import SidebarLayout from "../../Components/Layout/SidebarLayout";
import Tool from "../../Components/HighLevelComponents/Tool";
import config from "../../config";
import toolConfigs from "./config/toolsConfig";

const ToolsPage: React.FC = () => {
  const { toolId } = useParams<{ toolId: string }>();

  // Redirect to first tool if none selected
  if (!toolId) {
    return <Navigate to="/tools/quiz" replace />;
  }

  // Get the tool configuration
  const toolConfig = toolId ? toolConfigs[toolId] : null;

  // This key will force the Tool component to re-mount when the tool changes
  // which will reset all state inside the Tool component
  const toolKey = `tool-${toolId}`;

  return (
    <SidebarLayout>
      {toolConfig ? (
        <Tool
          key={toolKey}
          config={toolConfig}
          executeEndpoint={`${config.API_URI}/api/prompt`}
        />
      ) : (
        <div className="text-center p-10">
          <h1 className="text-2xl font-bold text-gray-800 mb-4">
            Tool Not Found
          </h1>
          <p className="text-gray-600">
            The tool you're looking for doesn't exist or is still under
            development.
          </p>
        </div>
      )}
    </SidebarLayout>
  );
};

export default ToolsPage;
